import { Badge, Box, Group, Image, Skeleton, Stack, Text } from "@mantine/core";
import styles from "./LiveFeedAsset.module.scss";
import { logger } from "utils/logger";
import { useState } from "react";

const LiveFeedAsset = ({ asset, onLoad, style={} }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <Box className={styles.asset}>
      <Image
        // radius={'md'}
        style={{ ...style, opacity: isLoaded?1:0, transition:'opacity .2s'}}
        src={asset.preview}
        onLoad={(e) => {
          logger.log("image loaded");
          onLoad();
            setTimeout(() => {
                setIsLoaded(true);
            },1000)
        }}
      />

      <Stack className={styles.metaBox} p={"md"} gap={"xs"}>
        <Text c={"white"} fw={"bold"}>
          {asset.style}
        </Text>
        <Text size="sm" c={"white"}>
          {asset.name}
        </Text>

        <Group gap={"5"}>
          {asset &&
            asset.tags &&
            asset.tags.length &&
            asset.tags.split(",").map((val, idx) => (
              <Badge
                key={idx}
                color="gray"
                variant="default"
                gradient={{ from: "#ed6ea0", to: "#ec8c69", deg: 35 }}
              >
                {val}
              </Badge>
            ))}
        </Group>
      </Stack>

      {!isLoaded ? (
        <Skeleton
          width={"100%"}
          height={"100%"}
          style={{ position: "absolute" }}
        />
      ) : null}
    </Box>
  );
};

export default LiveFeedAsset;
